import { inject, Injectable } from '@angular/core';
import { ApiDataAccess } from '@softline/core';
import {
  SOFTLINE_API_CUSTOMER_CONSTRUCTION_SITE,
  SOFTLINE_API_CUSTOMER_CONSTRUCTION_SITES,
  SOFTLINE_API_CUSTOMER_DELIVERY_CUSTOMERS,
} from '../customer-info.api';
import {
  ConstructionSiteRequest,
  ConstructionSiteResponse,
  DeliveryCustomer,
} from '../types/construction-site';

/** Write access to the construction sites (Baustellen) of an invoicing customer.
 *  Both write endpoints answer with the site's `customerId` only — callers that
 *  need master data load it via `CustomerRepository.getById`. */
@Injectable({ providedIn: 'root' })
export class ConstructionSiteRepository {
  private readonly dataAccess = inject(ApiDataAccess);

  create(
    customerId: string,
    request: ConstructionSiteRequest
  ): Promise<ConstructionSiteResponse> {
    return this.dataAccess.create<ConstructionSiteRequest, ConstructionSiteResponse>(
      { path: SOFTLINE_API_CUSTOMER_CONSTRUCTION_SITES, pathParams: { id: customerId } },
      request
    );
  }

  update(
    customerId: string,
    constructionSiteId: string,
    changes: ConstructionSiteRequest
  ): Promise<ConstructionSiteResponse> {
    return this.dataAccess.patch<ConstructionSiteRequest, ConstructionSiteResponse>(
      {
        path: SOFTLINE_API_CUSTOMER_CONSTRUCTION_SITE,
        pathParams: { id: customerId, constructionSiteId },
      },
      changes
    );
  }

  getDeliveryCustomers(customerId: string): Promise<DeliveryCustomer[]> {
    return this.dataAccess.get<DeliveryCustomer[]>({
      path: SOFTLINE_API_CUSTOMER_DELIVERY_CUSTOMERS,
      pathParams: { id: customerId },
    });
  }
}
